import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  /* faHome, */
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons'
import logo from '../assets/LogoPos2.png';
import {useHistory} from 'react-router-dom';
import {deleteCookies, deleteCookiesAdmin, deleteCookiesDoctor} from '../utils/functions';
import cookie from '../services/cookie/index';

export default function Main(props) {
  const {Page} = props;

  let history = useHistory();
  const [collapsed, setCollapsed] = useState(true);
  const toggleNavbar = () => setCollapsed(!collapsed);
  let role = cookie().get("role")

  return (
    <div>
      <Navbar color="faded" expand="md" light style={{borderBottom:'1px solid #ddd', background:'#FFF'}}>
      <NavbarBrand
          onClick={() => {
            window.location.reload(); // Recarregar a página ao clicar na logo
          }}
          className="mr-auto"
        >
          <img src={logo} alt="Logo CEDAP" style={{ height: '32px', cursor: 'pointer' }} />
        </NavbarBrand>

        <NavbarToggler onClick={toggleNavbar} className="mr-2" />

        <Collapse isOpen={!collapsed} navbar>
          <Nav className="mr-auto" navbar>

           {/*  <NavItem>
              <NavLink style={{cursor:'pointer'}} onClick={() => {setCollapsed(true); history.push({ pathname:"/"})}} ><FontAwesomeIcon icon={faHome} /> Home</NavLink>
            </NavItem> */}

            
            {role === "admin"&&
            <NavItem>
              <NavLink style={{cursor:'pointer'}} onClick={() => {setCollapsed(true); deleteCookiesAdmin(); history.push({ pathname:"/admin"})}} ><FontAwesomeIcon icon={faSignOutAlt} /> Sair</NavLink>
            </NavItem>
            }

            {role === "hmsj"&&
              <NavItem>
              <NavLink style={{cursor:'pointer'}} onClick={() => {setCollapsed(true); deleteCookiesDoctor(); history.push({ pathname:"/doctor"})}} ><FontAwesomeIcon icon={faSignOutAlt} /> Sair</NavLink>
            </NavItem>
            }
            {role === "paciente"&&
            <NavItem>
              <NavLink style={{cursor:'pointer'}} onClick={() => {setCollapsed(true); deleteCookies(); history.push({ pathname:"/login"})}} ><FontAwesomeIcon icon={faSignOutAlt} /> Sair</NavLink>
            </NavItem>
            }

            
          </Nav>
        </Collapse>

      </Navbar>

      <Page/>
    </div>
  );

}
